<form [formGroup]="formGroup">
    <input type="text"
           minlength="7"
           [formControl]="ctrlFullTag"
           [attr.placeholder]="placeholder"
           [attr.disabled]="disabled ? disabled : null"
           [aaAutocomplete]="tagac"
           class="ac-input" />
    <aa-autocomplete #tagac="autoComplete" [width]="250">
        <ng-template aaAutocompleteContent>
            <ng-container *ngIf="(tags| autocompleteFilter : ctrlFullTag.value : 'fullTagName') as result">
                <aa-autocomplete-option *ngFor="let tag of result"
                                        [value]="tag">
                    <div class="tag-search-item pointer"
                         (click)="onClick(tag)"
                         [style.color]="tag.fgColor"
                         [style.backgroundColor]="tag.bgColor">
                        {{ tag.fullTagName }}
                    </div>
                </aa-autocomplete-option>
                <aa-autocomplete-option *ngIf="result.length">
                    <div class="tag-search-item infos">
                        Click to select
                    </div>
                </aa-autocomplete-option>
                <aa-autocomplete-option *ngIf="!result.length">
                    <div class="tag-search-item infos">
                        No more tag...
                    </div>
                </aa-autocomplete-option>
            </ng-container>
        </ng-template>
    </aa-autocomplete>
</form>
